import * as classes from "./video-background.module.scss";
import classNames from "classnames";
import { FC, useEffect, useState } from "react";
import { debounce as _debounce } from "lodash";

interface Props {
  className: string;
  src: string;
  srcPortrait?: string;
}

const VideoBackground: FC<Props> = ({ className, src, srcPortrait }) => {
  const [currentSrc, setCurrentSrc] = useState<string>("");
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const onResize = _debounce(
      () => {
        if (window.innerHeight > window.innerWidth) {
          setCurrentSrc(srcPortrait);
        } else {
          setCurrentSrc(src);
        }
      },
      222,
      { leading: true, trailing: true }
    );

    if (!srcPortrait) {
      setCurrentSrc(src);
    } else {
      window.addEventListener("resize", onResize);
      onResize();
    }

    return () => {
      window.removeEventListener("resize", onResize);
    };
  }, []);

  return (
    <video
      onPlaying={() => setIsPlaying(true)}
      className={classNames(className, classes.root, {
        [classes["root--is-visible"]]: isPlaying,
      })}
      src={currentSrc}
      autoPlay
      muted
      loop
      playsInline
    />
  );
};

export default VideoBackground;
